import { useContext } from "react";
import { UserContext } from "../context/userContext";

/**
 * 編集可否を判定するカスタムフック。
 *
 * - canEdit: 認証済み・ゲストでない・管理者モードでない場合のみ true。
 *   isAdminMode が null（未確定）の場合は安全側に倒して編集不可とする。
 * - canOperate: 認証済み・ゲストでない場合に true（QR検索など管理者モードでも実行可能な操作用）。
 * - isAdmin: ユーザーが管理者権限を持っているか（UI表示の出し分け用）。
 */
export function useCanEdit() {
  const { isAuth, isGuest, isAdminMode, user } = useContext(UserContext);
  // isAdminMode が null（未確定）の場合は安全側に倒して編集不可
  const canEdit = isAuth === true && isGuest === false && isAdminMode === false;
  // QR検索など管理者モードでも操作可能なアクション用
  const canOperate = isAuth === true && isGuest === false;
  // ユーザーが管理者権限を持っているか（UI表示の出し分け用）
  const isAdmin = user?.is_admin === true;
  return { canEdit, canOperate, isAdmin };
}
